module.exports = __webpack_public_path__ + "img/egg.9f1aa5a4.png";